export const DietType = {
  VEGAN: 'vegan',
  VEGETARISCH: 'vegetarisch',
  MIT_FLEISCH: 'mit Fleisch',
  MIT_FISCH: 'mit Fisch',
  GEBÄCK: 'Gebäck',
}
